<template>
  <el-card class="static-page">
    <div style="text-align:right">
      <el-form ref="form" :model="form" label-width="50px" :inline="true">
        <el-form-item>
          <el-select v-model="title" filterable :placeholder="`搜索到${titleList.length}个标题`" style="width:100%" @change="titleChange" clearable>
            <el-option v-for="(item,value) in titleList" :key="value" :label="item.title" :value="item.title">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="userId" placeholder="请选择作者" clearable :style="{width:'100%'}" filterable remote :remote-method="getUserList" :loading="loading">
            <el-option v-for="item in userInfo" :key="item.userId" :label="item.fullName" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addStaticPage" icon="el-icon-circle-plus-outline">新建文档</el-button>
        </el-form-item>
        <el-form-item>
        </el-form-item>
        <span class="static-pages-tips">
          <el-tooltip class="item" effect="dark" placement="right-start">
            <div slot="content">
              <p>静态页面操作指南：</p>
              <p><span class="color-red">*</span>1. 显示：静态页面列表默认显示自己的作品。</p>
              <p><span class="color-red">*</span>2. 静态页面操作权限：
                <br /><br /> （1）所有人可编辑（writen）：所有用户可以编辑/删除当前的静态页面。
                <br /><br /> （2）仅个人查看/编辑（onlyMe）：仅当前用户查看或编辑静态页面，其他用户不可见。
                <br /><br /> （3）其他人只读/不可编辑（readOnly）：其他用户只能查看静态页面，无法编辑/删除。
              </p>
            </div>
            <el-button type="text">
              <i class="el-icon-question tips-icon"></i>
            </el-button>
          </el-tooltip>
        </span>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%" :empty-text="this.tabelText" :max-height="height" @row-dblclick="editStaticPage">
      <div class="empty-content" slot="empty">
        <p class="empty-text">一起来创建文档吧~</p>
      </div>
      <el-table-column prop="title" label="标题" sortable />
      <el-table-column label="页面地址">
        <template slot-scope="scope" v-if="scope.row.status == 1">
          <a :style="{color:'#1890ff'}" :href="locations+'/p/'+scope.row.id" target="_blank">{{ `${locations}/p/${scope.row.id}`}}</a>
        </template>
      </el-table-column>
      <el-table-column width="220" prop="author" label="作者" sortable>
        <template v-slot="{row}">
          <!-- style="color: #041677;" -->
          <span>{{row.author}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="220" sortable>
        <template slot-scope="scope">
          {{formatTime( scope.row.createTime )}}
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="220" sortable>
        <template slot-scope="scope">
          {{formatTime( scope.row.updateTime )}}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" sortable>
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 0">草稿</el-tag>
          <el-tag type="success" v-else>已发布</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button :disabled="hasPower(scope.row)" type="text" size="mini" @click="editStaticPage(scope.row)">修改</el-button>
          <el-button :disabled="hasPower(scope.row)" type="text" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          <el-dropdown trigger="click" v-if="scope.row.uid===user.id||scope.row.uid==''||user.isAdmin">
            <span class="el-dropdown-link">
              操作权限<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="updateStaticpagePower(scope.row,'writen')" icon="el-icon-edit-outline">所有人可编辑（writen）</el-dropdown-item>
              <el-dropdown-item @click.native="updateStaticpagePower(scope.row,'onlyMe')" icon="el-icon-user">仅个人查看/编辑（onlyMe）</el-dropdown-item>
              <el-dropdown-item @click.native="updateStaticpagePower(scope.row,'readOnly')" icon="el-icon-view">其他人只读/不可编辑（readOnly）</el-dropdown-item>
              <el-dropdown-item @click.native="updateStaticpagePower(scope.row,'innerNet')" icon="el-icon-postcard">只允许内网访问（innerNet）</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="right" background @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="pageConfig.pageNub" :page-sizes="[10, 15, 20, 30]" :page-size="pageConfig.pageSize" layout="total, prev, pager, next, sizes,jumper" :total="total">
    </el-pagination>
  </el-card>
</template>
<script>
import { pageApi, userApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      tableData: [], // 静态页面表格数据
      // 静态页面分页配置
      pageConfig: {
        pageNub: 1,  //当前页
        pageSize: 15 // 当前页显示数据总数
      },
      total: 0, // 数据总数
      titleTotal: 0, //标题总数
      titleList: [], // 标题列表
      title: '', // 当前标题
      form: {},
      tabelText: ' ',
      locations: process.env.NODE_ENV === 'development' ? window.location.origin + '/api' : window.location.origin,
      userId: '',// 用户ID
      loading: false, // loading
      // 作者列表
      userInfo: [{
        userId: '',
        fullName: ''
      }],
      height: '100%',
    }
  },
  computed: {
    ...mapGetters({ user: 'userInfo' })
  },
  watch: {
    userId () {
      // 清除定时器
      if (this.timer) {
        clearInterval(this.timer)
      }
      // 获取静态页面列表
      this.getStaticPagesList();
      // 获取静态页面标题
      this.getTitleName();
    }
  },
  mounted () {
    // 初始化用户列表
    this.initUserList();
    // 表格max-height响应式
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
  },
  methods: {
    // 是否拥有权限
    hasPower (row) {
      // 如果非管理员、非作者、非可写权限、作者非空   禁用按钮（没有权限）
      return !(row.uid === this.user.id || row.uid == '' || row.power === 'writen') && !this.user.isAdmin;
    },
    // 监听窗口变化
    onWindowResize () {
      this.$nextTick(() => {
        this.height = `${document.documentElement.clientHeight - 256}px`
      });
    },
    // 初始化用户列表
    initUserList () {
      this.timer = setInterval(() => {
        this.userInfo[0].userId = this.user.id || ''
        this.userInfo[0].fullName = this.user.fullName || ''
        this.userId = this.userInfo[0].userId
      }, 100)
    },
    // 获取用户列表
    getUserList (realName) {
      this.loading = true;
      setTimeout(async () => {
        this.loading = false
        const res = await userApi.getUserList({ realName })
        this.userInfo = res.userInfo
      }, 200);
    },
    // 删除
    handleDelete (row) {
      this.$confirm(`是否确认删除`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let param = {
          id: row.id
        }
        await pageApi.deleteStaticpage(param);
        this.$message.success('删除成功！')
        this.getStaticPagesList();
        this.getTitleName();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 跳转到编辑静态页面
    editStaticPage (row) {
      if (!(row.uid === this.user.id || row.uid == '' || row.power === 'writen') && !this.user.isAdmin) {
        return this.$message.warning('您没有操作权限~');
      }
      let param = {
        id: row.id
      }
      this.$router.push({ path: '/staticPage/addStaticPage', query: param });
    },
    // 跳转到新增静态页面
    addStaticPage () {
      this.$router.push({ path: '/staticPage/addStaticPage' });
    },
    // 获取标题列表
    async getTitleName () {
      const _res = await pageApi.getStaticpagesTitle({ title: this.title, uid: this.userId });
      this.titleList = _res.list;
      this.titleTotal = _res.total;
    },
    // 列表
    async getStaticPagesList () {
      showLoading()
      this.tableData = []
      let param = {
        title: this.title,
        uid: this.userId,
        ...this.pageConfig
      }
      try {

        const res = await pageApi.getStaticpages(param);
        if (res) {
          this.tableData = res.list;
          this.total = res.total;
          if (!res.list) {
            this.tabelText = '暂无数据!!';
          }
        }
      } catch (e) {
      }
      hideLoading()
    },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 当当前页数改变，触发事件
    handlePageChange (num) {
      this.pageConfig.pageNub = num;
      this.getStaticPagesList();
    },
    // 当页面显示数据总数改变，触发事件
    handleSizeChange (size) {
      this.pageConfig.pageSize = size;
      this.getStaticPagesList();
    },
    // 当标题筛选条件改变，触发事件
    titleChange () {
      this.pageConfig.pageNub = 1;
      this.getStaticPagesList();
    },
    // 静态页面权限修改
    async updateStaticpagePower (row, power) {
      const res = await pageApi.updateStaticpagePower({ id: row.id, cid: row.cid, power });
      if (res.code === 200) {
        this.$message.success('权限修改成功！');
      } else {
        this.$message.error('权限修改失败！');
      }
    }
  },
}
</script>
<style lang="scss">
.static-page {
  // height: 100%;
  position: relative;
  margin: 24px;
  border-radius: 16px !important;
  .el-dropdown-link {
    margin-left: 10px;
    font-size: 12px;
    cursor: pointer;
    color: #409eff;
  }
  .empty-content {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 400px;
    background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/no_data_1.png");
    background-repeat: no-repeat;
    background-size: 30%;
    background-position: center;
    .empty-text {
      font-size: 16px;
      font-weight: 500;
      color: #bcbcbc;
    }
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .static-pages-tips {
    position: absolute;
    top: 10px;
    left: 20px;
    .tips-icon {
      color: #5862ab;
      font-size: 25px;
    }
  }
}
.right {
  text-align: right;
  margin-top: 15px;
}
</style>